import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box, useTheme } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../../theme";
import Header from "../../../global_components/parameterized/Header";

const Recordings = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [recordingsData, setRecordingsData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/data/recordings`
        );
        setRecordingsData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const columns = [
    {
      field: "DriveID",
      headerName: "Drive ID",
      flex: 1,
    },
    {
      field: "RecordingID",
      headerName: "Recording ID",
      flex: 1,
    },
    {
      field: "StartTimeUTC",
      headerName: "Start (UTC)",
      flex: 1,
      valueFormatter: (params) => {
        return formatTimestamp(params.value);
      },
    },
    {
      field: "EndTimeUTC",
      headerName: "End (UTC)",
      flex: 1,
      valueFormatter: (params) => {
        return formatTimestamp(params.value);
      },
    },
    {
      field: "LatitudeNMEA",
      headerName: "Latitude NMEA",
      flex: 1,
    },
    {
      field: "LongitudeNMEA",
      headerName: "Longitude NMEA",
      flex: 1,
    },
    {
      field: "DayNight",
      headerName: "Day/Night",
      flex: 1,
    },
    {
      field: "WeatherConditions",
      headerName: "Weather Conditions",
      flex: 1,
    },
    {
      field: "Visibility",
      headerName: "Visibility",
      flex: 1,
    },
    {
      field: "Temperature",
      headerName: "Temperature[°C]",
      flex: 1,
    },
    {
      field: "Humidity",
      headerName: "Humidity[%]",
      flex: 1,
    },
    {
      field: "Precipitation",
      headerName: "Precipitation[mm]",
      flex: 1,
    },
    {
      field: "WindSpeed",
      headerName: "Wind Speed[km/h]",
      flex: 1,
    },
    {
      field: "PM10",
      headerName: "PM_10[μg/m³]",
      flex: 1,
    },
    {
      field: "PM25",
      headerName: "PM_25[μg/m³]",
      flex: 1,
    },

    {
      field: "CarbonMonoxide",
      headerName: "CO[μg/m³]",
      flex: 1,
    },

    {
      field: "Dust",
      headerName: "Dust[μg/m³]",
      flex: 1,
    },
  ];

  const formatTimestamp = (timestamp) => {
    const timestampString = timestamp.toString(); // Convert to string
    //if (timestampString.length === 6) {}
    const hh = timestampString.substring(0, 2);
    const mm = timestampString.substring(2, 4);
    const ss = timestampString.substring(4, 6);
    return `${hh}:${mm}:${ss}`;
  };

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between">
        <Header title="RECORDINGS" subtitle="List of Recordings" />
        <Box display="flex" justifyContent="space-between" gap="10px">
          <Box display="flex" alignItems="center">
            <Box>
              <img
                alt="ipeg-logo"
                width="240px"
                height="55px"
                src={`../../assets/IPeG_Logo.png`}
              />
            </Box>
          </Box>
          <Box display="flex" alignItems="center">
            <Box>
              <img
                alt="dfki-logo"
                width="230px"
                height="53px"
                src={`../../assets/DFKI_Logo_2.png`}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      {/* Changed the Height of the table */}
      <Box
        m="20px 0 0 0"
        // height="200"
        // width="100%"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.greenAccent[400],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.greenAccent[400],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <DataGrid
          checkboxSelection
          rows={recordingsData}
          columns={columns}
          getRowId={(row) => `${row["DriveID"]}-${row["RecordingID"]}`}
          slots={{
            toolbar: GridToolbar,
          }}
        />
      </Box>
    </Box>
  );
};

export default Recordings;
